export default "__VITE_ASSET__ffe98c58__"